@if (document) {
  <ion-card
    button="true"
    (click)="showUploadDocumentModal()"
    class="ion-no-margin"
  >
    <ion-card-content>
      <div class="notice">
        <p>
          {{ 'general.pending_documentation' | translate }}
        </p>
        <ion-icon
          slot="start"
          aria-hidden="true"
          src="../assets/material-symbols/notification_important_24dp.svg"
        ></ion-icon>
      </div>
      <div class="notice-more">
        @if (document.type === EDocumentType.BANK_OWNERSHIP_CERTIFICATE) {
          <p>
            <strong>{{ 'company.bank_account' | translate | uppercase }}</strong>
          </p>
          <p>{{ 'company.must_upload_bank' | translate }}</p>
        } @else if (document.type === EDocumentType.SOCIAL_SECURITY_PAYMENT_CERTIFICATE) {
          <p>
            <strong>{{ 'company.social_security' | translate | uppercase }}</strong>
          </p>
          @if (document.expiresOn) {
            <p>{{ 'company.expired_ss_certificate' | translate }} {{ document.expiresOn | dfnsFormat: 'PPPP' }}.</p>
          } @else {
            <p>{{ 'company.must_upload_ss' | translate }}</p>
          }
        } @else if (document.type === EDocumentType.TAX_AUTHORITIES_PAYMENT_CERTIFICATE) {
          <p>
            <strong>{{ 'company.tax_authorities' | translate | uppercase }}</strong>
          </p>
          @if (document.expiresOn) {
            <p>{{ 'company.expired_tax_certificate' | translate }} {{ document.expiresOn | dfnsFormat: 'PPPP' }}.</p>
          } @else {
            <p>{{ 'company.must_upload_tax' | translate }}</p>
          }
        } @else if (document.type === EDocumentType.ACTIVITY_LICENSE) {
          <p>
            <strong>{{ 'company.activity_license' | translate | uppercase }}</strong>
          </p>
          @if (document.expiresOn) {
            <p>{{ 'company.expired_al_certificate' | translate }} {{ document.expiresOn | dfnsFormat: 'PPPP' }}.</p>
          } @else {
            <p>{{ 'company.must_upload_al' | translate }}</p>
          }
        } @else if (document.type === EDocumentType.EUROPEAN_LICENSE) {
          <p>
            <strong>{{ 'company.european_license' | translate | uppercase }}</strong>
          </p>
          @if (document.expiresOn) {
            <p>{{ 'company.expired_el_certificate' | translate }} {{ document.expiresOn | dfnsFormat: 'PPPP' }}.</p>
          } @else {
            <p>{{ 'company.must_upload_el' | translate }}</p>
          }
        } @else if (document.type === EDocumentType.GOODS_ASSURANCE) {
          <p>
            <strong>{{ 'company.goods_assurance' | translate | uppercase }}</strong>
          </p>
          @if (document.expiresOn) {
            <p>{{ 'company.expired_ga_certificate' | translate }} {{ document.expiresOn | dfnsFormat: 'PPPP' }}.</p>
          } @else {
            <p>{{ 'company.must_upload_ga' | translate }}</p>
          }
        } @else if (document.type === EDocumentType.CIVIL_RESPONSABILITY_ASSURANCE) {
          <p>
            <strong>{{ 'company.cra' | translate | uppercase }}</strong>
          </p>
          @if (document.expiresOn) {
            <p>{{ 'company.expired_cra_certificate' | translate }} {{ document.expiresOn | dfnsFormat: 'PPPP' }}.</p>
          } @else {
            <p>{{ 'company.must_upload_cra' | translate }}</p>
          }
        }
        <p>{{ 'company.keep_up_to_date' | translate }}</p>
      </div>
    </ion-card-content>
  </ion-card>
}
